<template>
	<div>
		<div class="Authentication" v-if="userInfo.authenStatus !=1">
			 <el-button @click="$router.push({name:userInfo.userType==1?'enterpriseAuthe':'personalAuthentication' })">账号未认证，<span class="span">立即去认证</span></el-button>
		</div>
<!--		<div class="sign-property">-->
<!--			&lt;!&ndash; <div class="surplus-contract">剩余签署次数<span>3</span></div> &ndash;&gt;-->
<!--			<div class="cut-off-rule"></div>-->
<!--			<div class="surplus-download">还可下载模板<span>限时免费</span></div>-->
<!--		</div>-->
	</div>

</template>

<script>
	export default {
		data() {
			return {
				userInfo: {
					authenStatus:1
				},
				authStatus:1
			};
		},
		created(){
			this.userType = this.$SIF.getLocalStorage("userInfo").userType;
			this.get_userInfo()
			if(this.userType==1){
				this.get_manageAuthInfo()
			}else {
				this.get_ingo()
			}
		},
		methods: {
			get_userInfo() {
				var that = this;
				this.$SIF.getUserInfo({
					succFun: res => {
						that.userInfo = res.data;
					}
				});
			},
			get_manageAuthInfo() {
				this.$SIF.httpPost({
					url: this.$SIF._serve.auth + "/auth/company/query/companyAuthInfo",
					data: {},
					succFun: res => {
						if(res.data){
							this.authStatus=res.data.authStatus;
							this.$SIF.getUserInfo({
								succFun:res=> {
									this.userInfo = res.data;
									// this.$store.commit("SET_USERINFO", res.data);
									this.$SIF.setLocalStorage('userInfo', res.data)
								}
							});
							// if(this.authStatus==1){
							// 	var data ={
							// 		...this.$SIF.getLocalStorage("userInfo"),
							// 		authenStatus :1
							// 	}
							// 	this.$SIF.setLocalStorage('userInfo', data)
							// }

						}
						// this.$SIF.setLocalStorage('authStatus', res.data.authStatus)
						// this.$SIF.getLocalStorage("authStatus")
					}
				});
			},
			get_ingo(){
				this.$SIF.httpPost({
					url: this.$SIF._serve.auth + "/auth/Person/query/personinfo",
					succFun: res => {
						if(res.data){
							this.authStatus = res.data.authStatus
							this.$SIF.getUserInfo({
								succFun:res=> {
									this.userInfo = res.data;
									this.$SIF.setLocalStorage('userInfo', res.data)
								}
							});
						}else {
							this.authStatus =0
						}
					},failFun:res=>{
						this.$message({
							message: res.msg,
							type: 'warning'
						});
					}
				});
			}
		},
	}
</script>

<style lang="scss">
	.Authentication{
		width: 346px;
		height: 42px;
		position: absolute;
		top:62px;
		right: 400px;
		line-height: 42px;
		font-size: 14px;

	}
	.Authentication .el-button{
		border: none;
		color: #38BD81;
		float: right;
	}
	.Authentication .el-button .span{
		color: #F6A015;
	}
.sign-property{
	width: 346px;
	height: 42px;
	background-color:#D5F6E7;
	border-radius:3px;
	position: absolute;
	top:62px;
	right: 0px;
	line-height: 42px;
}
.sign-property div{
	float: left;
	margin: 0 10px ;
	font-size:12px;
	font-family:SourceHanSansCN-Regular,SourceHanSansCN;
	font-weight:400;
}
/*
 * 剩余合同
 */
.sign-property .surplus-contract{
	width: 100px;
	color:rgba(54,147,105,1);
}
.sign-property .surplus-contract span{
	font-size:18px;
	color:rgba(76,76,76,1);
	margin-left: 15px;
}
/*
 * 分割线
 */
.sign-property .cut-off-rule{
	background-color:#20A266 ;
	width:2px;
	height:19px;
	margin-top: 12px;
}
/*
 * 剩余下载
 */
.sign-property .surplus-download{
	width: 180px;
	color:rgba(54,147,105,1);
}
.sign-property .surplus-download span{
	color:#FF4141;
	font-size:14px;
	margin-left: 15px;
}
</style>